import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type KcBrowseLane = 'learn' | 'help';

/**
 * A titled browse lane (heading + marker + 3-col card grid) for the Knowledge Centre hub.
 *
 * Feature-local copy of the former `@pitchin/ui` `pin-kc-browse-lane` (ADR-0006).
 */
@Component({
  selector: 'kc-browse-lane',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="laneblock">
      <div class="lane-head tw-flex tw-items-center tw-gap-[10px] tw-my-[26px] tw-mb-[14px]">
        <h2 class="tw-text-[21px] tw-m-0 tw-font-semibold">{{ resolvedTitle }}</h2>
        <span [class]="markerClasses" class="lane-mark tw-text-[10.5px] tw-font-bold tw-uppercase tw-tracking-[.04em] tw-px-[9px] tw-py-[3px] tw-rounded-[5px]">{{ markerText }}</span>
        <span *ngIf="subtitle" class="tw-text-[#6a6a6a] tw-text-[13.5px]">&#8212; {{ subtitle }}</span>
      </div>
      <div class="cardgrid tw-grid tw-grid-cols-3 tw-gap-4">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class KcBrowseLaneComponent {
  @Input() lane: KcBrowseLane = 'learn';
  @Input() title?: string;
  @Input() subtitle?: string;

  get resolvedTitle(): string {
    return this.title ?? (this.lane === 'learn' ? 'Learn' : 'Help & FAQ');
  }

  get markerText(): string {
    return this.lane === 'learn' ? 'Education' : 'Quick answers';
  }

  get markerClasses(): string {
    return this.lane === 'learn'
      ? 'tw-text-[#1f5b8f] tw-bg-[#e7f0fa]'
      : 'tw-text-[#006927] tw-bg-[#C2F0CA]';
  }
}
